export default {
  zh: {
    home: {
      heroTitle: '全球连接 · 无界沟通',
      introText: '香港星辉致力于为全球移动用户与企业提供高效、低成本、即插即用的蜂窝数据，随时随地极速上网。',
      philosophyTitle: '经营理念',
      ph1: '用户至上',
      ph2: '技术赋能',
      ph3: '稳定保障',
      ph4: '连接未来',
      btnAboutUs: '了解我们',
      featuresTitle: '我们的服务优势',
      featuresSubTitle: '为您提供多场景全方位的蜂窝网络保障'
    },
    about: {
      title: '关于 香港星辉国际通信有限公司',
      subtitle: '致力于提供稳定、高效的出境高性价比可靠上网产品',
      storyTitle: '我们的故事',
      storyContent: '香港星辉国际通信有限公司 成立于2024年，依托海外运营商资源渠道，专注面向出境旅客、商务人士、跨境务工、留学生群体，提供实体国际流量 SIM 卡 + 数字化 eSIM 流量套餐一站式跨境上网解决方案，是深耕华人出境通信以及入境国内游客通信领域的专业服务商。',
      philosophyTitle: '我们的理念',
      philosophyContent: '正品运营商资源、网络稳定不降速、资费透明无隐形扣费、全流程售后兜底，打造出境高性价比可靠上网产品。',
      teamTitle: '认识我们的团队',
      backBtn: '返回首页',
      team: {
        leoBio: '手机充值行业资深人士，在科技创新领域拥有 15 年以上经验。',
        oscarBio: '专注于安全手机充值系统和高并发架构的技术领导者。',
        tommyBio: '在全球手机充值基础设施和资金安全方面具有专业知识的金融策略师。'
      }
    },
    refund: {
      title: '退换货政策',
      subtitle: 'RETURN & REFUND POLICY',
      noticeBanner: '为了保障您的合法权益，请在购买及使用国际流量卡产品前仔细阅读以下退换货条款。',
      fullRefundTitle: '1. 可全额退款 / 换货场景',
      physicalSimTitle: '实体 SIM 卡',
      physicalSimDesc: '未拆封、未激活、完好无损、包装齐全，且无任何使用记录。',
      esimTitle: 'SIM 套餐',
      esimDesc: '未扫码、未安装、未激活、无流量使用记录，且处于有效期内。',
      techTitle: '平台与技术原因',
      techDesc: '我方发货错误、卡号/套餐不符、产品本身故障或系统问题导致无法正常激活使用。',
      orderTitle: '订单异常',
      orderDesc: '重复下单、未生效订单，可直接申请全额退款。',
      partialRefundTitle: '2. 部分退款场景',
      networkIssueTitle: '网络与运营商故障：',
      networkIssueDesc: '因我方网络资源故障、运营商侧问题导致服务中断，经技术核实后，可按剩余有效时长/剩余流量比例办理部分退款。',
      nonHumanIssueTitle: '非人为原因额度退款：',
      nonHumanIssueDesc: '套餐未过期、仅少量使用，非用户人为原因故障，可协商剩余额度退款。',
      noRefundTitle: '3. 不予退换 / 不予退款场景（免责声明）',
      badgeUsed: '已使用',
      descUsed: '实体卡已拆封/已激活/已有联网记录；SIM 已扫码/已安装/已激活/已产生流量。',
      badgeDevice: '设备/环境',
      descDevice: '用户设备不兼容、手机未解锁、手动设置错误或当地信号环境问题导致无法使用。',
      badgePersonal: '个人原因',
      descPersonal: '出行计划变更、个人临时不需要、买错国家/套餐、忘记使用等个人原因。',
      badgeExpiry: '时效与损坏',
      descExpiry: '超过 30 天售后申请时效、套餐已过期失效；或私自改装、插拔损坏、人为损坏实体卡。',
      processTitle: '4. 退换货标准流程',
      step1Title: '联系客服提交凭证',
      step1Desc: '提供订单号、购买手机号、问题截图/视频及产品实拍照片。',
      step2Title: '寄回商品（仅实体卡）',
      step2Desc: '审核通过后按指定地址寄回，运费由用户承担（非我方责任场景）。',
      step3Title: '审核与原路退款',
      step3Desc: '核验无误后，款项将于 7–14 个工作日内原路退回。',
      specialTitle: '📌 特别说明',
      specialDescPre: '所有国际流量产品属于',
      specialDescHighlight: '虚拟通信服务 + 专属运营商资源',
      specialDescPost: '，一经激活即占用运营商通道与号段资源，无法二次销售复用，因此',
      specialDescNotice: '激活后不支持退换',
      specialDescEnd: '，敬请知悉与理解。'
    },
    faq: {
      title: '常见问题',
      searchPlaceholder: '搜索您遇到的问题（如：退款、设备不兼容...）',
      noResult: '未找到相关问题，请尝试更换关键词。',
      list: [
        {
          question: '实体SIM卡没拆封，可以全额退款吗？',
          answer: '购买30天内、全新未拆封未激活、包装完整，可申请全额退货退款。已拆封或已激活无法退换。'
        },
        {
          question: '激活后网络不好、卡顿降速，可以退款吗？',
          answer: '正常运营商网络波动、当地信号覆盖、用户设备设置问题不在退款范围内。经我方技术核实为运营商资源故障、通道问题，可按剩余额度部分退款或免费更换套餐。'
        },
        {
          question: '买错国家/天数套餐，还没用能换吗？',
          answer: '未激活未使用、订单30天内，可免费协助更换对应适配套餐；已激活使用无法更换。'
        },
        {
          question: '出行临时取消，不需要了能退吗？',
          answer: '个人行程变更属于个人原因，已激活产品不退，未激活产品可按售后规则申请退换。'
        },
        {
          question: '设备不兼容导致用不了，支持退款吗？',
          answer: '下单前请确认设备支持对应网络频段，设备不兼容、手机锁网等用户原因，不支持退款。'
        },
        {
          question: '退款多久能到账？',
          answer: '资料审核通过后，7–14个工作日原路返还，具体以银行/支付平台到账时效为准。'
        },
        {
          question: '产品过期没用，可以退款吗？',
          answer: '套餐过期自动失效，资源已锁定周期，超时未使用视为自动放弃，不支持售后退款。'
        },
        {
          question: 'B端批量采购可以单独定制售后政策吗？',
          answer: '企业/旅行社/劳务/留学机构批量合作，可专属洽谈定制售后、退换货与兜底服务方案。'
        }
      ]
    },
    adv1Title: '即买即用',
    adv1Desc: '卡插入设备即激活',
    adv2Title: '覆盖全球',
    adv2Desc: '覆盖 220+ 国家与地区高速 4G/5G 原生网络',
    adv3Title: '安全稳定',
    adv3Desc: '7×24小时专业技术客服与全天候监控保障',
    tabHome: '首页',
    tabRecharge: '充值',
    tabRefund: '退换货',
    tabFaq: '常见问题',
    tabProfile: '我的',
    rechargeTitle: '流量套餐充值',
    buyBtn: '订购',
    userTitle: 'SIM 卡用户',
    snCodeLabel: 'SN 码：',
    assetTitle: '套餐与资产信息',
    planBadge: '流量月卡',
    totalData: '总流量',
    usedData: '已用流量',
    remainingData: '剩余流量',
    orderHistoryTitle: '历史充值订单',
    logoutBtn: '退出登录',
    msgLogout: '已退出登录',
    contactInfo: {
      title: '联系我们',
      email: '电子邮件',
      address: '公司地址',
      tel: '座机',
      whatsapp: 'WhatsApp'
    }
  },
  en: {
    home: {
      heroTitle: 'Global Connection · Seamless Communication',
      introText: 'Hong Kong Starlight is dedicated to providing high-efficiency, low-cost, plug-and-play cellular data for global mobile users and enterprises, delivering high-speed internet anytime, anywhere.',
      philosophyTitle: 'Business Philosophy',
      ph1: 'Customer First',
      ph2: 'Tech Empowerment',
      ph3: 'Reliable Guarantee',
      ph4: 'Connect the Future',
      btnAboutUs: 'About Us',
      featuresTitle: 'Our Service Advantages',
      featuresSubTitle: 'Providing comprehensive cellular network support across multiple scenarios'
    },
    about: {
      title: 'About Hong Kong Starlight International Communications Limited',
      subtitle: 'Committed to delivering stable, high-efficiency, and cost-effective reliable outbound connectivity products',
      storyTitle: 'Our Story',
      storyContent: 'Founded in 2024, Hong Kong Starlight International Communications Limited relies on overseas carrier resource channels to focus on outbound travelers, business professionals, cross-border workers, and international students. We offer one-stop cross-border connectivity solutions through physical international SIM cards + digital eSIM data plans, serving as a professional provider deeply rooted in Chinese outbound and inbound communication services.',
      philosophyTitle: 'Our Philosophy',
      philosophyContent: 'Genuine carrier resources, stable high-speed network without throttling, transparent rates with no hidden fees, and full-process customer support guarantee to create cost-effective and reliable outbound internet products.',
      teamTitle: 'Meet Our Team',
      backBtn: 'Back to Home',
      team: {
        leoBio: 'A veteran in the mobile top-up industry with over 15 years of experience in technological innovation.',
        oscarBio: 'A tech leader focused on secure mobile top-up systems and high-concurrency architecture.',
        tommyBio: 'A financial strategist with expertise in global mobile top-up infrastructure and capital security.'
      }
    },
    refund: {
      title: 'Return & Refund Policy',
      subtitle: 'RETURN & REFUND POLICY',
      noticeBanner: 'To protect your legal rights, please carefully read the following return and refund terms before purchasing and using international data products.',
      fullRefundTitle: '1. Full Refund / Exchange Scenarios',
      physicalSimTitle: 'Physical SIM Card',
      physicalSimDesc: 'Unopened, inactivated, intact, complete packaging, and no usage history.',
      esimTitle: 'SIM Plan',
      esimDesc: 'Unscanned, uninstalled, inactivated, no data usage history, and within the validity period.',
      techTitle: 'Platform & Technical Reasons',
      techDesc: 'Shipping errors on our part, mismatched card/plan, product defect, or system issues preventing normal activation and usage.',
      orderTitle: 'Order Exceptions',
      orderDesc: 'Duplicate orders or unfulfilled orders can be applied for a direct full refund.',
      partialRefundTitle: '2. Partial Refund Scenarios',
      networkIssueTitle: 'Network & Carrier Failures:',
      networkIssueDesc: 'If service is interrupted due to network resource failures or carrier-side issues verified by technical staff, a partial refund can be processed based on the remaining valid duration/data ratio.',
      nonHumanIssueTitle: 'Non-Human Issue Quota Refund:',
      nonHumanIssueDesc: 'If the plan is unexpired, minimally used, and experiences non-user-caused faults, a partial refund for the remaining quota can be negotiated.',
      noRefundTitle: '3. Non-Returnable / Non-Refundable Scenarios (Disclaimer)',
      badgeUsed: 'Used',
      descUsed: 'Physical card opened/activated/has connection history; SIM scanned/installed/activated/generated data usage.',
      badgeDevice: 'Device / Environment',
      descDevice: 'Inability to use due to user device incompatibility, carrier-locked phone, incorrect manual settings, or local signal coverage issues.',
      badgePersonal: 'Personal Reasons',
      descPersonal: 'Personal reasons such as changes in travel plans, temporary lack of need, purchasing the wrong country/plan, or forgetting to use.',
      badgeExpiry: 'Timeliness & Damage',
      descExpiry: 'Exceeding the 30-day customer support window, plan expiration; or unauthorized modification, physical damage from improper insertion/removal.',
      processTitle: '4. Standard Return & Refund Process',
      step1Title: 'Contact Support & Submit Proof',
      step1Desc: 'Provide order number, registered phone number, issue screenshots/videos, and physical product photos.',
      step2Title: 'Return Item (Physical Cards Only)',
      step2Desc: 'After approval, ship back to the designated address. Shipping fees are borne by the user (non-company fault scenarios).',
      step3Title: 'Verification & Original Payment Refund',
      step3Desc: 'Upon successful verification, funds will be refunded to the original payment method within 7–14 business days.',
      specialTitle: '📌 Special Notice',
      specialDescPre: 'All international data products are ',
      specialDescHighlight: 'virtual telecom services + dedicated carrier resources',
      specialDescPost: '. Once activated, carrier channels and number resources are occupied and cannot be resold. Therefore, ',
      specialDescNotice: 'refunds or exchanges are not supported after activation',
      specialDescEnd: ', thank you for your understanding.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      searchPlaceholder: 'Search your issue (e.g., refund, device incompatibility...)',
      noResult: 'No relevant questions found. Please try different keywords.',
      list: [
        {
          question: 'Can I get a full refund if the physical SIM card is unopened?',
          answer: 'Within 30 days of purchase, brand new, unopened, inactivated, with complete packaging, you can apply for a full return and refund. Opened or activated cards cannot be returned or exchanged.'
        },
        {
          question: 'Can I get a refund if the network is poor or throttled after activation?',
          answer: 'Normal carrier network fluctuations, local signal coverage, and user device settings are not eligible for refunds. If technical verification confirms a carrier resource failure or channel issue, a partial refund based on the remaining balance or a free plan replacement can be provided.'
        },
        {
          question: 'I bought the wrong country/days plan, can I exchange it before using it?',
          answer: 'If inactivated and unused within 30 days of the order, we can assist in replacing it with a suitable plan for free. Exchanged/activated plans cannot be changed.'
        },
        {
          question: 'My trip was canceled, can I get a refund if I no longer need it?',
          answer: 'Travel itinerary changes are personal reasons. Activated products are non-refundable; inactivated products can be returned/exchanged according to customer service rules.'
        },
        {
          question: 'Is it refundable if my device is incompatible?',
          answer: 'Please verify that your device supports the corresponding network bands before placing an order. Incompatibility, carrier lock, and other user-side reasons do not qualify for a refund.'
        },
        {
          question: 'How long does a refund take to process?',
          answer: 'After the documents are approved, refunds will be returned to the original payment method within 7–14 business days. Actual arrival time depends on your bank/payment platform.'
        },
        {
          question: 'Can I get a refund if the product expires without being used?',
          answer: 'The plan automatically expires when out of date. Resources were reserved for that period, and failure to use it within the period is considered a forfeiture, which is not eligible for a refund.'
        },
        {
          question: 'Can B2B bulk purchases customize after-sales policies?',
          answer: 'For enterprise, travel agency, labor dispatch, and study-abroad agency bulk partnerships, custom after-sales, exchange, and coverage guarantee plans can be negotiated.'
        }
      ]
    },
    adv1Title: 'Instant Access',
    adv1Desc: 'Activated automatically upon insertion into your device',
    adv2Title: 'Global Coverage',
    adv2Desc: 'Coverage across 220+ countries and regions with high-speed 4G/5G native networks',
    adv3Title: 'Safe & Stable',
    adv3Desc: '24/7 professional technical support and all-weather network monitoring',
    tabHome: 'Home',
    tabRecharge: 'Recharge',
    tabRefund: 'Return & Refund',
    tabFaq: 'FAQ',
    tabProfile: 'Profile',
    rechargeTitle: 'Data Plan Top-Up',
    buyBtn: 'Order Now',
    userTitle: 'SIM Card User',
    snCodeLabel: 'SN Code:',
    assetTitle: 'Plan & Asset Information',
    planBadge: 'Monthly Data Pass',
    totalData: 'Total Data',
    usedData: 'Used Data',
    remainingData: 'Remaining Data',
    orderHistoryTitle: 'Recharge History',
    logoutBtn: 'Log Out',
    msgLogout: 'Logged out successfully',
    contactInfo: {
      title: 'Contact Us',
      email: 'Email',
      address: 'Address',
      tel: 'Tel',
      whatsapp: 'WhatsApp'
    }
  }
}